import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchFranchisorSettings, updateFranchisorSettings } from './actions';
import authUtils from '../../../auth/utils';
import FranchisorSettingsForm, { selector as franchisorSettingsFormSelector } from './SettingsForm';
import { withTranslation } from 'react-i18next';

class FranchisorSettings extends Component {

	constructor(props) {
		super(props);
		this.handleFranchisorSettingsSubmit = this.handleFranchisorSettingsSubmit.bind(this);
	}

	componentDidMount() {
		const { fetchFranchisorSettings, franchisorId } = this.props;
		fetchFranchisorSettings(franchisorId);
	}

	handleFranchisorSettingsSubmit(values) {
		const { updateFranchisorSettings, franchisorId } = this.props;
		updateFranchisorSettings(franchisorId, values);
	}

	render() {
		const { t, franchisorSettings, isReadonly, franchisorSettingsFormValues, timetableViewTypes, subscriptionCancellationRules } = this.props;

		// applied on the way into the form - mutating the stored entity here would make redux-form
		// compare initialValues against an object it had already changed under it
		const initialValues = franchisorSettings && franchisorSettings.distanceToNearbyCenters === 0
			? { ...franchisorSettings, distanceToNearbyCenters: 5 }		// default value
			: franchisorSettings;

		return (
			<FranchisorSettingsForm
				onSubmit={this.handleFranchisorSettingsSubmit}
				initialValues={initialValues}
				t={t}
				isReadonly={isReadonly}
				timetableViewTypes={timetableViewTypes}
				subscriptionCancellationRules={subscriptionCancellationRules}
				{...franchisorSettingsFormValues}
			/>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		entities: { franchisorSettings },
		configuration: { franchisor },
		auth: { currentUser },
		lookups: { timetableViewTypes, subscriptionCancellationRules }
	} = state;

	return {
		franchisorId: franchisor.id,
		franchisorSettings: franchisorSettings[franchisor.id],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'FranchisorSettings'),
		franchisorSettingsFormValues: franchisorSettingsFormSelector(state, 'enableCollectMedicalInformation',
			'enableGoogleAnalytics', 'enableCustomerChat', 'trackFacebookPixel', 'systemEmail', 'recommendNearbyCenters', 'requireAdditionalConsentOnInstalmentPayment',
			'subscriptionCancellationRule'),
		timetableViewTypes: timetableViewTypes,
		subscriptionCancellationRules: subscriptionCancellationRules
	};
};

const mapDispatchToProps = {
	fetchFranchisorSettings,
	updateFranchisorSettings
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FranchisorSettings));